import React, { useState, useEffect } from "react";

function ParticipatedTimer({ status, data, getProfile }) {
  const [timeRemaining, setTimeRemaining] = useState("");

  const calculateTimeRemaining = (targetTime) => {
    const now = new Date();
    const diff = new Date(targetTime) - now;

    if (diff <= 0) {
      getProfile();
      return "Time Ended";
    }
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);
    return `${days > 0 ? `${days}d ` : ""}${hours}h ${minutes}m ${seconds}s`;
  };
  // console.log(data, "data");
  const getTargetTime = () => {
    const currentTime = new Date();
    const endTime = new Date(data?.task?.endTime);
    const reviewTimePeriod = new Date(data?.task?.reviewTimePeriod);
    const coolDownPeriod = new Date(data?.task?.coolDownPeriod);
    const votingEndPeriod = new Date(data?.task?.votingEndPeriod);

    // if (
    //   data?.task?.status === "inProgress" &&
    //   currentTime < endTime &&
    //   data?.task?.status !== "ended"
    // ) {
    //   return endTime;
    // } else if (
    //   currentTime > endTime &&
    //   currentTime < reviewTimePeriod &&
    //   data?.task?.status !== "ended"
    // ) {
    //   return reviewTimePeriod;
    // }
    //  else if (
    //     currentTime > reviewTimePeriod &&
    //     currentTime < coolDownPeriod &&
    //     status === 'inDispute'
    // ) {
    //     return votingEndPeriod; // Timer for 'inDispute' status
    // } else if (currentTime > reviewTimePeriod && currentTime < coolDownPeriod) {
    //     return coolDownPeriod;
    // }
    if (
      currentTime < endTime && data?.task?.status === "inProgress"
    ) {
      return endTime;
    } else if (
      currentTime < reviewTimePeriod
    ) {
      return reviewTimePeriod;
    }
    else if (
      currentTime < coolDownPeriod
    ) {
      return coolDownPeriod; // Timer for 'inDispute' status
    } else if (currentTime < votingEndPeriod) {
      return votingEndPeriod;
    }
    return null; // No active timer
  };

  useEffect(() => {
    const targetTime = getTargetTime();
    if (!targetTime) {
      setTimeRemaining("Time Ended");
      return;
    }

    const updateTimer = () => {
      const remaining = calculateTimeRemaining(targetTime);
      setTimeRemaining(remaining);
    };

    updateTimer();
    const timerInterval = setInterval(updateTimer, 1000);

    return () => clearInterval(timerInterval); // Cleanup on component unmount
  }, [data, status]);

  return <p className="tablepara">{timeRemaining}</p>;
}

export default ParticipatedTimer;
